import type { Competition, Exercise } from '@/types/domain';

/**
 * Ejercicios que pueden puntuar en una competicion.
 *
 * Si la competicion fija una lista, esa. Si no —lo normal desde que el alta ya
 * no pide ejercicios—, cualquier ejercicio activo de su tematica: el atleta no
 * lo declara y el revisor pone el que aparece en el video.
 *
 * Ordenados de menor a mayor dificultad, para que el marcador provisional de
 * un envio sea siempre el mismo. Las funciones score-submission y
 * admin-score-submission aplican el mismo criterio en el servidor.
 */
export function eligibleExercises<
  T extends Pick<Exercise, 'id' | 'theme' | 'active' | 'difficulty_coefficient'>,
>(competition: Pick<Competition, 'theme' | 'allowed_exercise_ids'>, exercises: readonly T[]): T[] {
  const list = competition.allowed_exercise_ids ?? [];
  const eligible =
    list.length > 0
      ? exercises.filter((exercise) => list.includes(exercise.id))
      : exercises.filter((exercise) => exercise.active && exercise.theme === competition.theme);
  return [...eligible].sort((a, b) => a.difficulty_coefficient - b.difficulty_coefficient);
}
